<template>
    <scroll-wrap>
        <div class="main-box">
            <div class="content-wrap">
                <div class="country">
                    <img :src="require(`./../../assets/image/${$store.state.record.country}.png`)" alt="">
                </div>
                <div class="main-area">
                    <div class="main-area-box">
                        <div class="wrap">
                            <div class="item-box product">
                                <img :src="orderExp.order.product.pureImage" alt="">
                                <div class="orders">
                                    <span>
                                        订单需求量： <strong>{{orderExp.amount}}</strong>
                                    </span>
                                    <i class="iconfont icon-dingdan2"></i>
                                </div>
                            </div>
                            <div class="item-box warehouse">
                                <div class="item" :class="{active:item.id === outStore.outStoreExpId}"  v-for="(item,index) in list" :key="index" @click="outStore.outStoreExpId = item.id">
                                    <span class="name">
                                        {{item.store.name}} • {{item.store.location}}发货
                                    </span>
                                    <div class="box" :class="`box${index+1}`">
                                        <span>
                                            {{item.store.name}}存量：<strong>{{item.totalAmount}}</strong>
                                        </span>
                                        <i class="iconfont icon-xuanze-danxuan"></i>
                                    </div>
                                </div>
                            </div>
                            <div class="item-box map">
                                <img :src="orderExp.order.address" alt="">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="foot">
                <span class="btn" @click="$router.push($route.meta.next)" v-if="outStore.outStoreExpId!==''">
                    补仓申请
                </span>
            </div>
        </div>
    </scroll-wrap>
</template>

<script>
    export default {
        name: "investigate",
        data() {
            return {
                orderExp:{
                    order:{
                        product:{
                            pureImage:''
                        }
                    }
                },
                list:[],
                outStore:{id:'',outStoreExpId:''}
            }
        },
        created() {
            this.getList()
        },
        methods:{
            getList(){
                let num = 3;
                this.$store.commit('setState',{key: `record.caseIndex`, value: num})
                this.axios.post('/student/order/exp/create', {
                    experiment: {id: this.$store.state.record.experiment.id},
                    order:{product:{id:this.$store.state.record.template.id},type:num},
                }).then(res => {
                    if (res.succeed && res.login) {
                        this.orderExp = res.orderExp;
                        this.outStore.id = res.orderExp.id;
                        this.$store.commit('setState',{key: `record.orderExp_${num}`, value: res.orderExp})
                    }
                })
                this.axios.post('/student/store/exp/list',{experiment: {id:this.$store.state.record.experiment.id}}).then(res=>{
                    if(res.succeed && res.login){
                        this.list = res.items.filter((item,index) => {
                            return item.store.country === this.$store.state.record.country
                        });
                    }
                })
            },
            fahuo(){
                this.axios.post('/student/order/exp/deliver',this.outStore).then(res=>{
                    this.$router.push('/overseas-warehouses/checkAndRatify')
                })
            }
        }
    }
</script>

<style scoped lang="scss">
    .main-box {
        height: 100%;

        .content-wrap {
            display: flex;
            position: relative;
            min-height: calc(100% - 88px);
            justify-content: flex-start;
            flex-grow: 1;

            .country {
                position: relative;
                width: 364px;min-width:364px;

                img {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }
            }

            .main-area {
                flex-grow: 1;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                padding: 20px;

                h6 {
                    width: 100%;
                    text-align: left;
                    padding-left: 60px;
                    line-height: 60px;
                    font-size: 16px;

                    i {
                        color: red;
                        margin-right: 3px;
                    }

                    e {
                        color: #004BFF;
                    }
                }

                .main-area-box {
                    display: flex;
                    justify-content: center;
                    padding-bottom: 60px;

                    .wrap {
                        display: flex;
                        align-items: center;
                        .product {
                            height: 472px;
                            width: 200px;
                            margin-right: 136px;
                            position: relative;
                            &:before {
                                content: '';
                                position: absolute;
                                bottom: 0;
                                z-index: 1;
                                right: -68px;
                                width: 0;
                                height: 96%;
                                border-right: 1px dashed #5180FC;
                            }
                            &:after {
                                content: '';
                                position: absolute;
                                z-index: 2;
                                right: -84px;
                                bottom: 50%;
                                width: 32px;
                                height: 32px;
                                background: url("./../../assets/image/handleOrders/arrow-right.png");
                                background-size: cover;
                            }
                            div.orders {
                                width: 100%;
                                position: absolute;
                                left: 50%;
                                transform: translateX(-50%);
                                bottom: 30px;
                                display: flex;
                                flex-direction: column;
                                align-items: center;
                                span {
                                    color: #FFFFFF;
                                    font-size: 16px;
                                    strong {
                                        font-size: 24px;
                                        font-weight: bolder;
                                    }
                                }
                                i {
                                    margin-top: 10px;
                                    font-size: 30px;
                                    color: #FFFFFF;
                                }
                            }
                        }
                        .warehouse {
                            margin-right: 68px;
                            height: 100%;
                            display: flex;
                            flex-direction: column;
                            justify-content: space-evenly;
                            .item {
                                display: flex;
                                flex-direction: column;
                                align-items: flex-start;
                                justify-content: center;
                                cursor: pointer;
                                padding-right: 60px;
                                &.active {
                                    i {
                                        color: #FBB521;
                                    }
                                }
                                .box {
                                    width: 276px;
                                    height: 174px;
                                    border-radius: 10px;
                                    position: relative;
                                    &.box1 {
                                        background: url("./../../assets/image/A.png") 0 0 no-repeat;
                                        background-size: cover;
                                    }
                                    &.box2 {
                                        background: url("./../../assets/image/B.png") 0 0 no-repeat;
                                        background-size: cover;
                                    }
                                    > span {
                                        position: absolute;
                                        bottom: 6px;
                                        left: 50%;
                                        transform: translateX(-50%);
                                        font-size: 16px;
                                        color: #FFFFFF;
                                        > strong {
                                            font-size: 18px;
                                            font-weight: bolder;
                                        }
                                    }
                                    > i {
                                        position: absolute;
                                        right: -40px;
                                    }
                                }
                                span.name {
                                    font-size: 18px;
                                    font-weight: bolder;
                                    margin-bottom: 10px;
                                }
                                > div {
                                    display: flex;
                                    align-items: center;
                                    i {
                                        color: #9e9e9e;
                                        margin-left: 30px;
                                        font-size: 30px;
                                    }
                                }
                            }
                        }
                        div.map {
                            width: 420px;
                            height: 424px;
                            margin-top: 46px;
                        }
                    }
                }
            }
        }

        > .foot {
            background: #EEEFEF;
            display: flex;
            align-items: center;
            justify-content: center;border-radius:0 0 10px 10px;
            height: 88px;
            border-bottom-left-radius: 10px;
            border-bottom-right-radius: 10px;

            span.btn {
                cursor: pointer;
                padding: 10px 38px;
                background: #004BFF;
                color: #FFFFFF;
                border-radius: 100px;
                margin-right: 40px;

                &:hover {
                    opacity: 0.8;
                }

                &:last-child {
                    margin-right: 0;
                }
            }
        }
    }
</style>
